import { BiPencil } from "react-icons/bi";
import { PaddedIcon } from "../../../components/ui/button/Icon";
import Workspace from "../../../components/workspace";

const GroupType = ({ groupType, formModal, setSelected }) => {
   return (
      <Workspace.ItemWrapper
         onClick={() => {
            setSelected(groupType);
            formModal.onOpen();
         }}>
         <div className="flex items-center px-4 py-5 gap-x-4 md:gap-x-6">
            <input type="checkbox" onClick={(e) => e.stopPropagation()} />

            <div className="grid gap-x-3 grid-cols-12 w-full items-center">
               <p className="col-span-6 font-bold overflow-hidden overflow-ellipsis">{`${groupType.name}`}</p>
               <p className="col-span-4 text-sm">{groupType.description}</p>

               <Workspace.ItemActionsWrapper>
                  <PaddedIcon variant="primary" aria-label="edit">
                     <BiPencil className="text-lg" />
                  </PaddedIcon>
               </Workspace.ItemActionsWrapper>
            </div>
         </div>
      </Workspace.ItemWrapper>
   );
};

export { GroupType };
